import React, { useContext, useState } from 'react';
import { downloadChartPDF } from "./downloadChartPDF";
import { FullscreenContext } from './ChartFullscreenWrapper';
import {downloadChartPDFBar} from "./downloadChartPDFBar";

// Ikona pobierania (download)
const DownloadIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7 10 12 15 17 10" />
        <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
);

// Spinner - animowana ikona ładowania
const LoadingSpinner = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{
        animation: 'spin 1s linear infinite',
    }}>
        <style>{`
            @keyframes spin {
                from { transform: rotate(0deg); }
                to { transform: rotate(360deg); }
            }
        `}</style>
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
    </svg>
);

// Ikona fullscreen - strzałki rozszerzające się pod kątem 45 stopni (lewa dół / prawa góra)
const FullscreenIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {/* Górna prawa strzałka */}
        <polyline points="17 7 22 2 22 7" />
        <line x1="22" y1="2" x2="10" y2="14" />

        {/* Dolna lewa strzałka */}
        <polyline points="7 17 2 22 2 17" />
        <line x1="2" y1="22" x2="14" y2="10" />
    </svg>
);

function ChartDownloadWrapper({ children, chartId, chartTitle, officialOrderName, type, onFullscreenClick }) {
    const { isFullscreen } = useContext(FullscreenContext);
    const [isDownloading, setIsDownloading] = useState(false);
    const title = chartTitle || chartId.replace('chart-', '');

    const handleDownload = async ()  => {
        // Zapobiegaj wielokrotnemu klikaniu
        if (isDownloading) return;

        try {
            setIsDownloading(true);

            if(type === 'bar') {
                if (isFullscreen) {
                    // Pobierz z fullscreen containera
                    await downloadChartPDFBar(chartId, title, officialOrderName, true);
                } else {
                    // Pobierz z normalnego widoku
                    await downloadChartPDFBar(chartId, title, officialOrderName, false);
                }
            } else {
                if (isFullscreen) {
                    // Pobierz z fullscreen containera
                    await downloadChartPDF(chartId, title, officialOrderName, true);
                } else {
                    // Pobierz z normalnego widoku
                    await downloadChartPDF(chartId, title, officialOrderName, false);
                }
            }
        } catch (error) {
            console.error('Error downloading chart:', error);
        } finally {
            setIsDownloading(false);
        }
    };

    const iconStyle = {
        cursor: isDownloading ? 'not-allowed' : 'pointer',
        color: isDownloading ? '#ccc' : 'lightgrey',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '6px',
        borderRadius: '4px',
        opacity: isDownloading ? 0.6 : 1
    };

    return (
        <div data-chart-container style={{ width: '100%', position: 'relative' }} id={chartId}>
            {children}
            <div
                onClick={handleDownload}
                style={{
                    position: 'absolute',
                    bottom: '0px',
                    right: '30px',
                    zIndex: 10,
                    ...iconStyle
                }}
                onMouseEnter={(e) => {
                    if (!isDownloading) {
                        e.currentTarget.style.color = '#999';
                        e.currentTarget.style.backgroundColor = 'rgba(153, 153, 153, 0.1)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isDownloading) {
                        e.currentTarget.style.color = 'lightgrey';
                        e.currentTarget.style.backgroundColor = 'transparent';
                    }
                }}
                title={isDownloading ? "Generating PDF..." : "Download"}
            >
                {isDownloading ? <LoadingSpinner /> : <DownloadIcon />}
            </div>
        </div>
    );
}

export default ChartDownloadWrapper;